// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discount_title_component {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.discount_amount_input {
  width: 300px;
  border: 1px solid var(--border);
  border-radius: 5px;
  padding: 0px 10px;
  line-height: 2rem;
  font-size: 16px;
}

.discount_button_submit {
  padding: 7px 20px;
  border-radius: 4px;
  background-color: var(--primary);
  border: solid 1px var(--primary);
  color: white;
}

.discount_button_submit:disabled {
  background-color: var(--primary)6d;
  border: solid 1px var(--primary)6d;
}

.modal_header_alpaca{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: solid 1px #ccc;
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.modal_title_alpaca {
  margin: 0;
}

.close_x_icone{
  cursor: pointer;
}

.mb-10{
  margin-bottom: 10px;
}

.discount_item_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1rem;
}

.discount_item_box label {
  width: 100px;
  margin-right: 15px;
}

.discount_modal_input_container {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 15px;
  width: 100%;
}

.discount_modal_input_container input {
  max-width: 100%;
  border: 1px solid var(--border);
  padding: 10px 15px;
  border-radius: 4px;
  width: 90%;
}

.discount_actual_container {
  display: flex;
  flex-direction: column;
}

.discount_actual_infos_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid grey;
  border-radius: 15px;
  background-color: rgba(230, 230, 230, 0.278);
  height: 3rem;
  padding: 0px 20px;
  margin-bottom: 2rem;
}


`, "",{"version":3,"sources":["webpack://./src/pages/cadeaux/subpages/Discount/Discount.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".discount_title_component {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.discount_amount_input {\n  width: 300px;\n  border: 1px solid var(--border);\n  border-radius: 5px;\n  padding: 0px 10px;\n  line-height: 2rem;\n  font-size: 16px;\n}\n\n.discount_button_submit {\n  padding: 7px 20px;\n  border-radius: 4px;\n  background-color: var(--primary);\n  border: solid 1px var(--primary);\n  color: white;\n}\n\n.discount_button_submit:disabled {\n  background-color: var(--primary)6d;\n  border: solid 1px var(--primary)6d;\n}\n\n.modal_header_alpaca{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  border-bottom: solid 1px #ccc;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n}\n\n.modal_title_alpaca {\n  margin: 0;\n}\n\n.close_x_icone{\n  cursor: pointer;\n}\n\n.mb-10{\n  margin-bottom: 10px;\n}\n\n.discount_item_box {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.discount_item_box label {\n  width: 100px;\n  margin-right: 15px;\n}\n\n.discount_modal_input_container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  gap: 15px;\n  width: 100%;\n}\n\n.discount_modal_input_container input {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  padding: 10px 15px;\n  border-radius: 4px;\n  width: 90%;\n}\n\n.discount_actual_container {\n  display: flex;\n  flex-direction: column;\n}\n\n.discount_actual_infos_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid grey;\n  border-radius: 15px;\n  background-color: rgba(230, 230, 230, 0.278);\n  height: 3rem;\n  padding: 0px 20px;\n  margin-bottom: 2rem;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
